<div
  role="dialog"
  aria-labelledby="modalAddEditContactTitle"
  aria-hidden="true"
  >
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        @if (step === 0) {
          <h4 class="modal-title" id="modalAddEditContactTitle">
            {{ isNew ? ('shared.contactEditLib.add' | translate) : ('shared.contactEditLib.edit' | translate) }} {{ 'shared.contactEditLib.contact' | translate }}
          </h4>
        } @else if (step !== 0) {
          <h4 class="modal-title" id="modalAddEditContactTitle">
            {{ 'shared.contactEditLib.openAttendanceConfirmationTitle' | translate }}
          </h4>
        }
        <button
          type="button"
          class="btn-close"
          [mat-dialog-close]="true"
          aria-hidden="true"
        ></button>
      </div>
      <div class="modal-body custom-scroll-bar">
        @if (step === 0) {
          <form [formGroup]="formGroup">
            <div class="row">
              <div class="col-lg-6 mb-3">
                <label class="form-label">
                  {{ 'shared.contactEditLib.name' | translate }}
                  <span class="text-danger">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  maxlength="255"
                  formControlName="name"
                  [placeholder]="'shared.contactEditLib.namePlaceholder' | translate"
                  required
                  />
                <field-error-component
                  [field]="'name'"
                  [label]="'shared.contactEditLib.name' | translate"
                  [formGroup]="formGroup"
                  />
              </div>
              <div class="col-lg-6 mb-3">
                <label class="form-label">{{ 'shared.contactEditLib.email' | translate }}</label>
                <input
                  class="form-control"
                  maxlength="100"
                  formControlName="email"
                  [placeholder]="'shared.contactEditLib.emailPlaceholder' | translate"
                  />
                <field-error-component
                  [field]="'email'"
                  [label]="'shared.contactEditLib.email' | translate"
                  [formGroup]="formGroup"
                  />
              </div>
            </div>
            <div class="row">
              <div class="col-lg-3 mb-3">
                <label class="form-label">
                  {{ 'shared.contactEditLib.country' | translate }} <span class="text-danger">*</span>
                </label>
                <select
                  class="form-control"
                  (change)="onCountryChange($event)"
                  formControlName="country"
                  >
                  <option [value]="null" selected>{{ 'shared.contactEditLib.select' | translate }}</option>
                  @for (country of countries; track $index) {
                    <option [value]="country.code">
                      {{
                      selectedCountryCode === country.code
                      ? country.flag + " " + country.code
                      : country.name
                      }}
                    </option>
                  }
                </select>
                <field-error-component
                  [field]="'country'"
                  [label]="'shared.contactEditLib.country' | translate"
                  [formGroup]="formGroup"
                  />
              </div>
              <div class="col-lg-4 mb-3">
                <label class="form-label">
                  {{ 'shared.contactEditLib.phone' | translate }}
                  <span class="text-danger">*</span>
                </label>
                <input
                  (keypress)="keyPressOnlyNumbers($event)"
                  class="form-control"
                  maxlength="25"
                  formControlName="phone"
                  placeholder="000000000"
                  [mask]="phoneMask"
                  required
                  />
                <field-error-component
                  [field]="'phone'"
                  [label]="'shared.contactEditLib.phone' | translate"
                  [formGroup]="formGroup"
                  />
              </div>
              @if (contact?.whatsapp?.bsuid) {
                <div class="col-lg-4 mb-3">
                  <label class="form-label">BSUID (WhatsApp)</label>
                  <input
                    class="form-control"
                    [value]="$safeNavigationMigration(contact?.whatsapp?.bsuid)"
                    readonly
                    disabled
                    />
                </div>
              }
              <div class="col-lg-3 mb-3">
                <label class="form-label">{{ 'shared.contactEditLib.tin' | translate }}</label>
                <input
                  class="form-control"
                  maxlength="100"
                  formControlName="tin"
                  [mask]="'000.000.000-00'"
                  placeholder="000.000.000-00"
                  />
              </div>
              <div class="col-lg-2 mb-3">
                <label class="form-label">{{ 'shared.contactEditLib.gender' | translate }}</label>
                <mat-select class="form-control" formControlName="gender">
                  @for (gender of listGenders; track gender) {
                    <mat-option [value]="gender">
                      {{
                      gender === "MALE"
                      ? ('shared.contactEditLib.genderMale' | translate)
                      : gender === "FEMALE"
                      ? ('shared.contactEditLib.genderFemale' | translate)
                      : ('shared.contactEditLib.genderOther' | translate)
                      }}
                    </mat-option>
                  }
                </mat-select>
              </div>
            </div>
            <div class="row">
              <div
                class="col-lg-4 mb-2 trend-datepicker flex-column"
                (click)="picker.open()"
                tabindex="0"
                role="button"
                >
                <label class="form-label">{{ 'shared.contactEditLib.birthDate' | translate }}</label>
                <div class="d-flex">
                  <input
                    class="form-control"
                    [matDatepicker]="picker"
                    formControlName="birthDate"
                    [readonly]="true"
                    (keydown)="$event.preventDefault()"
                    (focus)="picker.open()"
                    [max]="today"
                    [matDatepickerFilter]="notInFuture"
                    placeholder="dd/mm/aaaa"
                    />
                  <mat-datepicker-toggle
                    matIconSuffix
                    [for]="picker"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #picker [startAt]="startAt"></mat-datepicker>
                </div>
                <field-error-component [field]="'birthDate'" [label]="'shared.contactEditLib.birthDate' | translate" [formGroup]="formGroup">
                </field-error-component>
              </div>
              <div class="col-lg-4 mb-2">
                <label class="form-label">{{ 'shared.contactEditLib.company' | translate }}</label>
                <input
                  type="text"
                  class="form-control"
                  formControlName="contactCompany"
                  [placeholder]="'shared.contactEditLib.companyPlaceholder' | translate"
                  />
              </div>
              <div class="col-lg-4 mb-2">
                <label class="form-label">{{ 'shared.contactEditLib.position' | translate }}</label>
                <input
                  type="text"
                  class="form-control"
                  formControlName="contactPosition"
                  [placeholder]="'shared.contactEditLib.positionPlaceholder' | translate"
                  />
              </div>
            </div>
            <div class="row my-3">
              <h5>{{ 'shared.contactEditLib.otherInformation' | translate }}</h5>
            </div>
            <div class="row">
              <div class="col-lg-4 mb-3">
                <label class="form-label">{{ 'shared.contactEditLib.zip' | translate }}</label>
                <input
                  [mask]="'00.000-000'"
                  class="form-control"
                  formControlName="zip"
                  [placeholder]="'shared.contactEditLib.zipPlaceholder' | translate"
                  (ngModelChange)="onCep($event)"
                  />
              </div>
              <div class="col-lg-8 mb-3">
                <label class="form-label">{{ 'shared.contactEditLib.address' | translate }}</label>
                <input class="form-control" formControlName="address" />
              </div>
            </div>
            <div class="row">
              <div class="col-lg-10 mb-3">
                <label class="form-label">{{ 'shared.contactEditLib.city' | translate }}</label>
                <input class="form-control" formControlName="city" />
              </div>
              <div class="col-lg-2 mb-3">
                <label class="form-label">{{ 'shared.contactEditLib.state' | translate }}</label>
                <mat-select class="form-control" formControlName="state" readonly>
                  @for (uf of ufOptions; track uf) {
                    <mat-option [value]="uf.key">
                      {{ uf.key }}
                    </mat-option>
                  }
                </mat-select>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6 mb-3">
                <label class="form-label">{{ 'shared.contactEditLib.groups' | translate }}</label>
                <mat-select
                  class="form-control"
                  formControlName="groups"
                  multiple
                  [placeholder]="'shared.contactEditLib.select' | translate"
                  >
                  <input
                    class="input-select-filter form-control"
                    type="text"
                    (focus)="onFocusGroup()"
                    [formControl]="filterControlGroup"
                    [placeholder]="'shared.contactEditLib.searchGroup' | translate"
                    />
                  @for (item of allGroups; track item) {
                    <mat-option [value]="item._id">{{ item.name }}</mat-option>
                  }
                </mat-select>
              </div>
              <div class="col-lg-6 mb-3">
                <label class="form-label">{{ 'shared.contactEditLib.tags' | translate }}</label>
                <mat-select class="form-control" formControlName="tags" multiple>
                  <input
                    class="input-select-filter form-control"
                    type="text"
                    (focus)="onFocusTags()"
                    [formControl]="filterControlTags"
                    />
                  @for (item of allTags; track item) {
                    <mat-option [value]="item._id">{{ item.title }}</mat-option>
                  }
                </mat-select>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12 mb-3">
                <label class="form-label">{{ 'shared.contactEditLib.customFields' | translate }}</label>
                <mat-select
                  class="form-control"
                  formControlName="selectedFields"
                  (selectionChange)="updateCustomFields($event.value)"
                  multiple
                  >
                  <input
                    class="input-select-filter form-control"
                    type="text"
                    (focus)="onFocusCustomFields()"
                    [formControl]="filterCustomField"
                    />
                  @for (item of allFieldsCustom; track item) {
                    <mat-option [value]="item._id">{{ item.name }}</mat-option>
                  }
                </mat-select>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12 mb-3">
                <div formArrayName="customFields">
                  @for(field of customFields.controls; track $index) {
                    <div [formGroupName]="$index">
                      @switch (getFieldType(field.get('_id').value)) {
                        @case('TEXT') {
                          <div class="mb-3">
                            <label class="form-label">
                              {{ getFieldName(field.get('_id').value) }}
                            </label>
                            <input
                              type="text"
                              class="form-control"
                              formControlName="value"
                              />
                          </div>
                        }
                        @case('NUMBER') {
                          <div class="mb-3">
                            <label class="form-label">
                              {{ getFieldName(field.get("_id").value) }}
                            </label>
                            <input
                              type="number"
                              class="form-control"
                              formControlName="value"
                              />
                          </div>
                        }
                        @case('FREETEXT') {
                          <div class="mb-3">
                            <label class="form-label">
                              {{ getFieldName(field.get("_id").value) }}
                            </label>
                            <textarea
                              class="form-control"
                              style="width: 100%; resize: none; outline: none"
                              maxlength="320"
                              formControlName="value"
                            ></textarea>
                          </div>
                        }
                        @case('DATE') {
                          <div class="mb-3">
                            <label class="form-label">
                              {{ getFieldName(field.get("_id").value) }}
                            </label>
                            <div class="d-flex trend-datepicker">
                              <input
                                class="form-control"
                                [matDatepicker]="fieldsPicker"
                                formControlName="value"
                                [readonly]="true"
                                (keydown)="$event.preventDefault()"
                                (focus)="fieldsPicker.open()"
                                placeholder="dd/mm/aaaa"
                                />
                              <mat-datepicker-toggle
                                matIconSuffix
                                [for]="fieldsPicker"
                              ></mat-datepicker-toggle>
                              <mat-datepicker #fieldsPicker></mat-datepicker>
                            </div>
                          </div>
                        }
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          </form>
        } @else if (step !== 0){
          <p class="text-muted fw-normal mb-0">
            {{ 'shared.contactEditLib.openAttendanceConfirmationText' | translate }}
          </p>
        }
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-light" (click)="close()">
          {{ 'shared.contactEditLib.cancel' | translate }}
        </button>

        @if (step === 0) {
          <button type="button" class="btn btn-primary" (click)="save()">
            {{ !loading ? (isNew ? ('shared.contactEditLib.save' | translate) : ('shared.contactEditLib.edit' | translate)) : "" }}

            @if(loading) {
              <mat-spinner
                [diameter]="25"
                [color]="'accent'"
                mode="indeterminate"
                />
            }
          </button>
        } @else if (step !== 0) {
          <button
            type="button"
            class="btn btn-primary"
            (click)="newConversation()"
            >
            {{ 'shared.contactEditLib.openAttendance' | translate }} @if(loading) {
            <mat-spinner
              [diameter]="25"
              [color]="'accent'"
              mode="indeterminate"
              />
          }
        </button>
      }
    </div>
  </div>
</div>
</div>
